{
    "metric_explainer__title": "Erklärung der Kennzahlen",
    "metric_explainer__erp_divergence": "Plato rechnet auf Positionsebene: jede Auftrags- und Rechnungsposition zählt einzeln. Ein teilfakturierter Auftrag geht mit seinen fakturierten Positionen in den Umsatz ein.",
    "metric_explainer__acl_note": "Zahlen umfassen nur Kunden, die du sehen darfst.",
    "metric__billed__label": "Umsatz",
    "metric__billed__definition": "Summe der fakturierten Positionen, auch aus teilfakturierten Aufträgen. Gutschriften mindern den Umsatz. Stornierte Positionen zählen nicht.",
    "metric__billed__date_basis": "Gebucht auf das Fakturadatum.",
    "metric__billed_wo_credit_note__label": "Umsatz (ohne Gutschriften)",
    "metric__billed_wo_credit_note__definition": "Summe der fakturierten Positionen, auch aus teilfakturierten Aufträgen, ohne Gutschriften.",
    "metric__billed_wo_credit_note__date_basis": "Gebucht auf das Fakturadatum.",
    "metric__not_billed__label": "Noch nicht fakturiert",
    "metric__not_billed__definition": "Wert der erfassten, aber noch nicht fakturierten Auftragspositionen. Stornierte und verlorene Positionen zählen nicht.",
    "metric__not_billed__date_basis": "Gebucht auf das Erfassungsdatum.",
    "metric__order_sum__label": "Auftragseingang",
    "metric__order_sum__definition": "Wert aller erfassten Auftragspositionen unabhängig von ihrem Fakturierungsstatus. Stornierte Positionen zählen nicht.",
    "metric__order_sum__document_types": "Gezählt werden die Belegarten {{documentTypes}}.",
    "metric__order_sum__date_basis": "Gebucht auf das Erfassungsdatum des Auftrags.",
    "metric__gross_margin__label": "Deckungsbeitrag (DB)",
    "metric__gross_margin__definition": "Summe der Deckungsbeiträge der Positionen, die {{base}} bilden. Den Wert je Position liefert die Warenwirtschaft.",
    "metric__gross_margin_percentage__label": "Deckungsbeitrag % (DB %)",
    "metric__gross_margin_percentage__definition": "Deckungsbeitrag derselben Positionen geteilt durch {{base}}.",
    "metric__units__label": "Menge",
    "metric__units__definition": "Summe der Positionsmengen in der Mengeneinheit der Warenwirtschaft. Unterschiedliche Einheiten werden ohne Umrechnung addiert.",
    "base__billed": "den Umsatz",
    "base__billed_wo_credit_note": "den Umsatz ohne Gutschriften",
    "base__not_billed": "den noch nicht fakturierten Wert",
    "base__order_sum": "den Auftragseingang",
    "base__order_value": "den Auftragswert",
    "base__quote_value": "den Angebotswert",
    "base__selected_figure": "die gewählte Kennzahl",
    "document_type__ORDER": "Auftrag",
    "document_type__CREDITNOTE": "Gutschrift",
    "document_type__QUOTE": "Angebot",
    "document_type__RETURN": "Retoure",
    "document_type__CONTRACT": "Kontrakt",
    "document_type__DEBIT_MEMO_REQUEST": "Nachbelastung",
    "document_type__CREDIT_MEMO_REQUEST": "Gutschriftsanforderung",
    "saved_views__all_views": "Alle Ansichten",
    "saved_views__my_views": "Meine Ansichten",
    "saved_views__shared_views": "Geteilte Ansichten",
    "saved_views__delete": "Löschen",
    "saved_views__delete_confirmation_title": "Filteransicht löschen",
    "saved_views__delete_confirmation_description": "Bist du sicher, dass du diese Filteransicht löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "save_view_dialog__title": "Ansicht speichern",
    "save_view_dialog__name_placeholder": "Namen eingeben",
    "save_view_dialog__save_button": "Speichern",
    "saved_views__presets": "Voreinstellungen",
    "saved_views__save_as_new": "Als neue Ansicht speichern …",
    "saved_views__save_error": "Die Ansicht konnte nicht gespeichert werden",
    "saved_views__delete_error": "Die Ansicht konnte nicht gelöscht werden",
    "save_view_dialog__share_with_team": "Mit meinem Team teilen",
    "saved_views__more_views": "Weitere Ansichten",
    "saved_views__view": "Ansicht",
    "saved_views__save_changes": "Änderungen speichern",
    "saved_views__revert": "Zurücksetzen",
    "relative_timestamp__just_now": "gerade eben"
}
